// Placar na visao da equipe: o mesmo do telao, com a propria linha destacada.

import { useQuery } from "@tanstack/react-query";
import type { ScoreboardDto } from "@compila/shared";
import { api } from "../../lib/api.js";
import { useSession } from "../../lib/hooks.js";
import { Scoreboard } from "../../components/Scoreboard.js";
import { ErrorBox, FrozenBanner, Spinner } from "../../components/ui.js";

export function TeamScoreboardPage(): React.JSX.Element {
  const session = useSession();
  const board = useQuery({
    queryKey: ["scoreboard"],
    queryFn: () => api.get<ScoreboardDto>("/scoreboard"),
  });

  if (board.isPending) return <Spinner />;
  if (board.error) return <ErrorBox message={(board.error as Error).message} />;

  return (
    <div className="space-y-4">
      {board.data.contest.frozen && (
        <div className="flex justify-center">
          <FrozenBanner />
        </div>
      )}
      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <Scoreboard
          board={board.data}
          {...(session.data?.teamId ? { highlightTeamId: session.data.teamId } : {})}
        />
      </div>
    </div>
  );
}
